(() => {
  if (window.MayLondonCapsuleUI) return;
  window.MayLondonCapsuleUI = {initialize(root, {state, open, selectionImage, readSizes, preview}) {
    const panel = root.querySelector('[data-capsule]');
    if (!panel || !window.MayLondonCapsule) return;
    const P = window.MayLondonCapsule, I = window.MayLondonI18n, E = window.MayLondonStyleEngine;
    const strings = JSON.parse(panel.querySelector('[data-capsule-strings]').textContent);
    const shared = JSON.parse(root.querySelector('[data-studio-strings]').textContent);
    const t = key => strings[key] || shared[key], find = name => panel.querySelector('[data-capsule-'+name+']');
    const form = find('form'), selectedOwn = new Set(), knownOwn = new Set();
    let draft, chosen = new Set();
    const node = (tag,text) => { const el=document.createElement(tag); if(text != null) el.textContent=text; return el; };
    const text = (key,values={}) => t(key).replace(/\{(\w+)\}/g,(_,name)=>I.number(values[name] || 0));
    const reset = (message = '') => { draft=undefined; chosen.clear(); find('results').hidden=true; find('looks').replaceChildren(); find('additions').replaceChildren(); find('status').textContent=message; find('open').disabled=true; };
    function inputs() {
      const data=Object.fromEntries(new FormData(form)), current=state();
      return {filters:{...readSizes(form),season:data.season,occasion:data.occasion}, options:{maxAdditions:Number(data.maxAdditions), target:Number(data.target), budget:Math.round(Number(data.budget)*100), own:current.own.filter(item=>selectedOwn.has(item.id)), cart:current.cart}};
    }
    function render() {
      if (!draft) return;
      const current=state(), result=P.selected(current.products,draft.filters,{...draft.options,cart:current.cart},[...chosen]);
      find('results').hidden=false; find('total').textContent=I.money(result.subtotal);
      find('open').disabled=!result.additions.length || !current.ready;
      find('status').textContent=result.looks.length ? text('summary',{looks:result.looks.length,pieces:result.additions.length,owned:result.reused})+(result.complete?'':' '+text('partial',{shown:result.looks.length,target:result.target})) : t('empty');
      const list=find('looks'); list.replaceChildren();
      result.looks.forEach((look,index)=>{
        const article=node('article'), title=node('h4',shared.your_look+' '+I.number(index+1)); article.append(title); preview(article,look.lines);
        const names=node('ul');
        for(const line of look.lines){const item=line.kind==='own'?current.own.find(p=>p.id===line.id):current.products.find(p=>p.handle===line.handle);names.append(node('li',(item?.name||item?.title||shared.unavailable)+(line.kind==='own'?' ('+shared.own+')':'')));}
        const button=node('button',shared.load); button.type='button'; button.addEventListener('click',()=>open(look.lines));
        article.append(names,button); list.append(article);
      });
      find('open').onclick=()=>open(result.additions);
    }
    function additions(lines, hasLooks) {
      const list=find('additions'), current=state(); list.replaceChildren();
      if(!lines.length) list.append(node('p',hasLooks?t('no_additions'):shared.empty));
      for(const line of lines){
        const product=current.products.find(p=>p.handle===line.handle), article=node('article');
        if(!product) continue;
        const choice=selectionImage(product,true,box=>{box.checked?chosen.add(line.handle):chosen.delete(line.handle);render();});
        article.append(choice,window.MayLondonStyleCatalog.colours(product),node('strong',I.money(E.price(product,draft.filters)))); list.append(article);
      }
    }
    function refresh() {
      const current=state(), wasPlanned=Boolean(draft); reset(wasPlanned?t('changed'):'');
      find('create').disabled=!current.ready;
      if(!current.ready) find('status').textContent=t('unavailable');
      const list=find('owned'); list.replaceChildren();
      const existing=new Set(current.own.map(item=>item.id));
      for(const id of knownOwn) if(!existing.has(id)){knownOwn.delete(id);selectedOwn.delete(id);}
      if(!current.own.length) list.append(node('p',t('no_owned')));
      for(const item of current.own){
        if(!knownOwn.has(item.id)){knownOwn.add(item.id);selectedOwn.add(item.id);}
        const label=node('label'), checkbox=node('input');checkbox.type='checkbox';checkbox.checked=selectedOwn.has(item.id);checkbox.value=item.id;
        label.append(checkbox,node('span',item.name+' / '+shared[item.category]));
        checkbox.addEventListener('change',()=>{checkbox.checked?selectedOwn.add(item.id):selectedOwn.delete(item.id);reset(t('changed'));});list.append(label);
      }
      for(const field of ['season','occasion']){
        const select=form.elements[field], value=select.value;
        const values=[...new Set(current.products.filter(p=>E.matches(p)).flatMap(p=>E.facts(p,field)))].sort();
        const all=node('option',shared.all);all.value=''; select.replaceChildren(all);
        for(const entry of values){const option=node('option',shared[entry]||entry);option.value=entry;select.append(option);}
        select.value=values.includes(value)?value:'';select.disabled=!values.length;
      }
    }
    form.addEventListener('input',event=>{if(event.target.name) reset(t('changed'));});
    form.addEventListener('submit',event=>{
      event.preventDefault(); if(!form.reportValidity() || !state().ready) return;
      try{
        draft=inputs();const result=P.plan(state().products,draft.filters,draft.options);
        chosen=new Set(result.additions.map(line=>line.handle)); additions(result.additions,result.looks.length>0); render();
      }catch(_){reset(shared.error);}
    });
    refresh();
    return {refresh,clear(){form.reset();selectedOwn.clear();knownOwn.clear();reset();refresh();}};
  }};
})();
